import { createSlice } from "@reduxjs/toolkit"

const fbAuthSlice = createSlice({
  name: "fbAuth",
  initialState: {
    fbToken: null,
    verifyFbTokenLoading: false,
    verifyFbTokenError: null,
  },
  reducers: {
    verifyFbTokenLoading: (state) => {
      state.verifyFbTokenLoading = true
      state.verifyFbTokenError = null
    },
    verifyFbTokenSuccess: (state, action) => {
      state.fbToken = action.payload
      state.verifyFbTokenLoading = false
      state.verifyFbTokenError = null
    },
    verifyFbTokenFailure: (state, action) => {
      state.verifyFbTokenLoading = false
      state.verifyFbTokenError = action.payload
    },
  },
})

export const {
  verifyFbTokenLoading,
  verifyFbTokenSuccess,
  verifyFbTokenFailure,
} = fbAuthSlice.actions

export default fbAuthSlice.reducer
